import { render, staticRenderFns } from "./InformationCommunity.vue?vue&type=template&id=5bc6d369&scoped=true"
import script from "./InformationCommunity.vue?vue&type=script&lang=js"
export * from "./InformationCommunity.vue?vue&type=script&lang=js"
import style0 from "./InformationCommunity.vue?vue&type=style&index=0&id=5bc6d369&prod&scoped=true&lang=css"
import style1 from "./InformationCommunity.vue?vue&type=style&index=1&id=5bc6d369&prod&lang=css"
import style2 from "./InformationCommunity.vue?vue&type=style&index=2&id=5bc6d369&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6d369",
  null
  
)

export default component.exports